import React, { useState, FC } from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { BriefIcon } from '@fiverr-private/icons';

import { getContext } from '@fiverr-private/fiverr_context';
import { useCurrentPageName } from '@fiverr-private/seller_pages_toolbox';
import { Container } from '@fiverr-private/layout_components';
import { AgencyBriefDrawer } from '../AgencyBriefDrawer';
import { EVENT_TYPE, bigQuery } from '../../monitoring/bigQuery';
import {
    ContactButtonPosition,
    contactButtonBiEnrichment,
} from '../../monitoring/bigQuery/createContactButtonEventEnrichment';
import { mixpanel } from '../../monitoring/mixpanel';

interface AgencyCreateBriefButtonProps {
    biSource: ContactButtonPosition;
}

export const AgencyCreateBriefButton: FC<AgencyCreateBriefButtonProps> = ({ biSource }) => {
    const { userId } = getContext();
    const source = useCurrentPageName();

    const [isShowDrawer, setIsShowDrawer] = useState(false);
    const [isDrawerLoading, setIsDrawerLoading] = useState(false);

    const onClick = () => {
        bigQuery.clickEvent(
            EVENT_TYPE.CLICKED_ON_CREATE_BRIEF_BUTTON,
            contactButtonBiEnrichment({ position: biSource })
        );
        mixpanel.event(`${biSource} - Create brief button clicked`);

        if (!userId) {
            return window.openSignUpModal?.({}, { source });
        }

        setIsShowDrawer(true);
        setIsDrawerLoading(true);
    };

    const closeDrawer = () => {
        setIsShowDrawer(false);
        setIsDrawerLoading(false);
    };

    return (
        <Container>
            <Button onClick={onClick}>
                <BriefIcon color="currentColor" />
                <I18n k="agency_page_perseus.create_brief" />
            </Button>
            <AgencyBriefDrawer
                isShow={isShowDrawer}
                isLoading={isDrawerLoading}
                closeDrawer={closeDrawer}
                onLoadingChange={setIsDrawerLoading}
                componentName={biSource}
            />
        </Container>
    );
};
